import { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonButton from "components/ArgonButton";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import TextField from "@mui/material/TextField";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Menu from "@mui/material/Menu";

// Sample data for units
const unitsData = [
  {
    id: "A101",
    floorplan: "Studio",
    sqft: 550,
    beds: 0,
    baths: 1,
    rent: 1250,
    status: "Available",
    availableDate: "Immediate",
  },
  {
    id: "A102",
    floorplan: "Studio",
    sqft: 575,
    beds: 0,
    baths: 1,
    rent: 1275,
    status: "Available",
    availableDate: "06/01/2025",
  },
  {
    id: "B201",
    floorplan: "1BD-A",
    sqft: 675,
    beds: 1,
    baths: 1,
    rent: 1450,
    status: "Occupied",
    availableDate: "07/15/2025",
  },
  {
    id: "B202",
    floorplan: "1BD-B",
    sqft: 700,
    beds: 1,
    baths: 1,
    rent: 1500,
    status: "Occupied",
    availableDate: "08/01/2025",
  },
  {
    id: "C301",
    floorplan: "2BD-A",
    sqft: 950,
    beds: 2,
    baths: 2,
    rent: 1950,
    status: "Available",
    availableDate: "Immediate",
  },
  {
    id: "C302",
    floorplan: "2BD-B",
    sqft: 1000,
    beds: 2,
    baths: 2,
    rent: 2050,
    status: "Maintenance",
    availableDate: "06/15/2025",
  },
  {
    id: "D401",
    floorplan: "3BD-A",
    sqft: 1250,
    beds: 3,
    baths: 2,
    rent: 2750,
    status: "Occupied",
    availableDate: "09/01/2025",
  },
  {
    id: "D402",
    floorplan: "3BD-B",
    sqft: 1300,
    beds: 3,
    baths: 2.5,
    rent: 2950,
    status: "Reserved",
    availableDate: "06/10/2025",
  },
  {
    id: "A103",
    floorplan: "Studio",
    sqft: 550,
    beds: 0,
    baths: 1,
    rent: 1250,
    status: "Available",
    availableDate: "Immediate",
  },
  {
    id: "B203",
    floorplan: "1BD-A",
    sqft: 675,
    beds: 1,
    baths: 1,
    rent: 1475,
    status: "Available",
    availableDate: "06/05/2025",
  },
  {
    id: "C303",
    floorplan: "2BD-A",
    sqft: 950,
    beds: 2,
    baths: 2,
    rent: 1975,
    status: "Occupied",
    availableDate: "07/30/2025",
  },
];

// Sample data for floorplans
const floorplansData = [
  {
    id: "Studio",
    description: "Open concept studio apartment",
    minSqft: 550,
    maxSqft: 575,
    beds: 0,
    baths: 1,
    baseRent: 1250,
    units: 3,
    available: 2,
  },
  {
    id: "1BD-A",
    description: "One bedroom with balcony",
    minSqft: 675,
    maxSqft: 675,
    beds: 1,
    baths: 1,
    baseRent: 1450,
    units: 2,
    available: 1,
  },
  {
    id: "1BD-B",
    description: "One bedroom with den",
    minSqft: 700,
    maxSqft: 700,
    beds: 1,
    baths: 1,
    baseRent: 1500,
    units: 1,
    available: 0,
  },
  {
    id: "2BD-A",
    description: "Two bedroom, two bath standard",
    minSqft: 950,
    maxSqft: 950,
    beds: 2,
    baths: 2,
    baseRent: 1950,
    units: 2,
    available: 1,
  },
  {
    id: "2BD-B",
    description: "Two bedroom, two bath corner unit",
    minSqft: 1000,
    maxSqft: 1000,
    beds: 2,
    baths: 2,
    baseRent: 2050,
    units: 1,
    available: 0,
  },
  {
    id: "3BD-A",
    description: "Three bedroom standard",
    minSqft: 1250,
    maxSqft: 1250,
    beds: 3,
    baths: 2,
    baseRent: 2750,
    units: 1,
    available: 0,
  },
  {
    id: "3BD-B",
    description: "Three bedroom premium with 2.5 baths",
    minSqft: 1300,
    maxSqft: 1300,
    beds: 3,
    baths: 2.5,
    baseRent: 2950,
    units: 1,
    available: 0,
  },
];

// Import PropTypes for component validation
import PropTypes from "prop-types";

// Helper function to get status color
const getStatusColor = (status) => {
  switch (status) {
    case "Available":
      return "success";
    case "Occupied":
      return "info";
    case "Reserved":
      return "warning";
    case "Maintenance":
      return "error";
    default:
      return "default";
  }
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

// Add PropTypes validation
TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

function Units() {
  const [tabValue, setTabValue] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // Filter units based on unified search
  const filteredUnits = unitsData.filter((unit) => {
    if (searchTerm === "") return true;
    const search = searchTerm.toLowerCase();
    return (
      unit.id.toLowerCase().includes(search) ||
      unit.floorplan.toLowerCase().includes(search) ||
      unit.status.toLowerCase().includes(search) ||
      unit.availableDate.toLowerCase().includes(search) ||
      unit.rent.toString().includes(search)
    );
  });

  // Get unique status values for filter dropdown
  const statusOptions = [...new Set(unitsData.map((unit) => unit.status))];

  // Get unique floorplan values for filter dropdown
  const floorplanOptions = [...new Set(unitsData.map((unit) => unit.floorplan))];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <ArgonBox py={3} sx={{ overflowX: 'hidden', width: '100%' }}>
        <Card sx={{ overflow: "hidden", width: '100%', maxWidth: '100%' }}>
          <ArgonBox p={3} display="flex" justifyContent="space-between" alignItems="center">
            <ArgonBox>
              <ArgonTypography variant="h4" fontWeight="medium">
                Units & Floorplans
              </ArgonTypography>
              <ArgonTypography variant="body2" color="text" mt={1}>
                Manage your property&apos;s units and floorplans in one place
              </ArgonTypography>
            </ArgonBox>
            <ArgonBox display="flex" gap={1}>
              <ArgonButton color="info" size="small">
                <Icon>file_download</Icon>&nbsp;Export
              </ArgonButton>
              <ArgonButton color="success" size="small">
                <Icon>add</Icon>&nbsp;Add Unit
              </ArgonButton>
              <ArgonButton color="primary" size="small">
                <Icon>add</Icon>&nbsp;Add Floorplan
              </ArgonButton>
            </ArgonBox>
          </ArgonBox>

          <ArgonBox sx={{ borderBottom: 1, borderColor: "divider", px: 3 }}>
            <Tabs value={tabValue} onChange={handleTabChange} aria-label="units and floorplans tabs">
              <Tab label="Units" />
              <Tab label="Floorplans" />
              <Tab label="Analytics" />
            </Tabs>
          </ArgonBox>

          <TabPanel value={tabValue} index={0}>
            <ArgonBox px={3} mb={3} sx={{ width: '100%', overflowX: 'hidden' }}>
              <Grid container spacing={2} alignItems="center" sx={{ width: '100%', margin: 0 }}>
                <Grid item xs={12} md={6}>
                  <TextField
                    id="search-units"
                    label="Search units"
                    variant="outlined"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    size="small"
                    InputProps={{
                      startAdornment: <Icon sx={{ mr: 1, color: "text.secondary" }}>search</Icon>,
                    }}
                    sx={{
                      width: '300px',
                      '& .MuiOutlinedInput-root': {
                        backgroundColor: 'white',
                        '& input': {
                          padding: '8px 4px',
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} display="flex" justifyContent="flex-end">
                  <ArgonButton color="secondary" variant="outlined" size="small">
                    <Icon>filter_list</Icon>&nbsp;More Filters
                  </ArgonButton>
                </Grid>
              </Grid>
            </ArgonBox>

            <ArgonBox px={3} sx={{ width: '100%', overflowX: 'hidden' }}>
              <TableContainer component={Paper} sx={{ boxShadow: "none", width: '100%', overflow: 'hidden', maxWidth: '100%' }}>
                <Table sx={{ width: '100%', tableLayout: 'auto', minWidth: '800px' }} aria-label="units table">
                  <TableHead>
                    <TableRow sx={{ '& > *': { borderBottom: '2px solid', borderColor: 'divider', fontWeight: 'bold' } }}>
                      <TableCell sx={{ padding: '8px 16px', minWidth: '80px' }}>Unit ID</TableCell>
                      <TableCell sx={{ padding: '8px 16px', minWidth: '100px' }}>Floorplan</TableCell>
                      <TableCell align="center" sx={{ padding: '8px', minWidth: '80px' }}>Sq. Ft.</TableCell>
                      <TableCell align="center" sx={{ padding: '8px', minWidth: '60px' }}>Beds</TableCell>
                      <TableCell align="center" sx={{ padding: '8px', minWidth: '70px' }}>Baths</TableCell>
                      <TableCell align="center" sx={{ padding: '8px', minWidth: '90px' }}>Rent</TableCell>
                      <TableCell sx={{ padding: '8px 16px', minWidth: '100px' }}>Status</TableCell>
                      <TableCell sx={{ padding: '8px 16px', minWidth: '140px' }}>Available Date</TableCell>
                      <TableCell align="center" sx={{ padding: '8px', minWidth: '80px' }}>Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredUnits
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((unit) => (
                        <TableRow key={unit.id} sx={{ "&:last-child td, &:last-child th": { border: 0 }, '&:hover': { bgcolor: 'action.hover' } }}>
                          <TableCell component="th" scope="row" sx={{ padding: '8px 16px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {unit.id}
                          </TableCell>
                          <TableCell sx={{ padding: '8px 16px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{unit.floorplan}</TableCell>
                          <TableCell align="center" sx={{ padding: '8px' }}>{unit.sqft}</TableCell>
                          <TableCell align="center" sx={{ padding: '8px' }}>{unit.beds}</TableCell>
                          <TableCell align="center" sx={{ padding: '8px' }}>{unit.baths}</TableCell>
                          <TableCell align="center" sx={{ padding: '8px' }}>${unit.rent}</TableCell>
                          <TableCell sx={{ padding: '8px 16px' }}>
                            <Chip
                              label={unit.status}
                              color={getStatusColor(unit.status)}
                              size="small"
                            />
                          </TableCell>
                          <TableCell sx={{ padding: '8px 16px', overflow: 'hidden', textOverflow: 'ellipsis' }}>{unit.availableDate}</TableCell>
                          <TableCell align="center" sx={{ padding: '8px' }}>
                            <ArgonButton
                              color="secondary"
                              size="small"
                              iconOnly
                              onClick={handleMenuClick}
                            >
                              <Icon>more_vert</Icon>
                            </ArgonButton>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
                <Menu
                  id="unit-actions-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleMenuClose}
                >
                  <MenuItem onClick={handleMenuClose}>
                    <Icon fontSize="small" sx={{ mr: 1 }}>edit</Icon> Edit
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose}>
                    <Icon fontSize="small" sx={{ mr: 1 }}>visibility</Icon> View Details
                  </MenuItem>
                  <MenuItem onClick={handleMenuClose}>
                    <Icon fontSize="small" sx={{ mr: 1 }}>attach_money</Icon> Update Rent
                  </MenuItem>
                  <Divider />
                  <MenuItem onClick={handleMenuClose}>
                    <Icon fontSize="small" sx={{ mr: 1 }}>delete</Icon> 
                    <ArgonTypography color="error" variant="button">Delete</ArgonTypography>
                  </MenuItem>
                </Menu>
              </TableContainer>
              
              <ArgonBox display="flex" justifyContent="space-between" alignItems="center" px={2} py={1} sx={{ width: '100%', maxWidth: '100%' }}>
                <ArgonBox display="flex" alignItems="center" gap={1}>
                  <ArgonTypography variant="caption" fontSize="0.75rem">
                    Rows per page:
                  </ArgonTypography>
                  <FormControl size="small" sx={{ minWidth: '60px' }}>
                    <Select
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      sx={{
                        fontSize: '0.75rem',
                        height: '32px',
                        '& .MuiSelect-select': {
                          padding: '4px 8px',
                          fontSize: '0.75rem',
                        },
                      }}
                    >
                      <MenuItem value={5} sx={{ fontSize: '0.75rem' }}>5</MenuItem>
                      <MenuItem value={10} sx={{ fontSize: '0.75rem' }}>10</MenuItem>
                    </Select>
                  </FormControl>
                </ArgonBox>
                
                <ArgonBox display="flex" alignItems="center" gap={1}>
                  <ArgonTypography variant="caption" fontSize="0.75rem">
                    {page * rowsPerPage + 1}-{Math.min((page + 1) * rowsPerPage, filteredUnits.length)} of {filteredUnits.length}
                  </ArgonTypography>
                  <ArgonBox display="flex" gap={0.5}>
                    <ArgonButton 
                      size="small" 
                      color="secondary" 
                      variant="outlined"
                      disabled={page === 0}
                      onClick={(e) => handleChangePage(e, page - 1)}
                      sx={{ minWidth: '32px', width: '32px', height: '32px', padding: 0 }}
                    >
                      <Icon fontSize="small">chevron_left</Icon>
                    </ArgonButton>
                    <ArgonButton 
                      size="small" 
                      color="secondary" 
                      variant="outlined"
                      disabled={page >= Math.ceil(filteredUnits.length / rowsPerPage) - 1}
                      onClick={(e) => handleChangePage(e, page + 1)}
                      sx={{ minWidth: '32px', width: '32px', height: '32px', padding: 0 }}
                    >
                      <Icon fontSize="small">chevron_right</Icon>
                    </ArgonButton>
                  </ArgonBox>
                </ArgonBox>
              </ArgonBox>
            </ArgonBox>
          </TabPanel>

          <TabPanel value={tabValue} index={1}>
            <ArgonBox px={3}>
              <Grid container spacing={3}>
                {floorplansData.map((floorplan) => (
                  <Grid item xs={12} md={6} lg={4} key={floorplan.id}>
                    <Card sx={{ height: "100%" }}>
                      <ArgonBox p={2}>
                        <ArgonBox display="flex" justifyContent="space-between" alignItems="center">
                          <ArgonTypography variant="h5">{floorplan.id}</ArgonTypography>
                          <ArgonButton
                            color="secondary"
                            size="small"
                            iconOnly
                            onClick={handleMenuClick}
                          >
                            <Icon>more_vert</Icon>
                          </ArgonButton>
                        </ArgonBox>
                        <ArgonTypography variant="body2" color="text">
                          {floorplan.description}
                        </ArgonTypography>
                        <ArgonBox mt={2}>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <ArgonTypography variant="caption" color="text">
                                Size
                              </ArgonTypography>
                              <ArgonTypography variant="body2">
                                {floorplan.minSqft === floorplan.maxSqft
                                  ? `${floorplan.minSqft} sq ft`
                                  : `${floorplan.minSqft}-${floorplan.maxSqft} sq ft`}
                              </ArgonTypography>
                            </Grid>
                            <Grid item xs={6}>
                              <ArgonTypography variant="caption" color="text">
                                Layout
                              </ArgonTypography>
                              <ArgonTypography variant="body2">
                                {floorplan.beds} bed / {floorplan.baths} bath
                              </ArgonTypography>
                            </Grid>
                            <Grid item xs={6}>
                              <ArgonTypography variant="caption" color="text">
                                Base Rent
                              </ArgonTypography>
                              <ArgonTypography variant="body2">
                                ${floorplan.baseRent}
                              </ArgonTypography>
                            </Grid>
                            <Grid item xs={6}>
                              <ArgonTypography variant="caption" color="text">
                                Availability
                              </ArgonTypography>
                              <ArgonTypography variant="body2">
                                {floorplan.available} of {floorplan.units} units
                              </ArgonTypography>
                            </Grid>
                          </Grid>
                        </ArgonBox>
                        <ArgonBox mt={2} display="flex" gap={1}>
                          <ArgonButton color="info" size="small" fullWidth>
                            <Icon>visibility</Icon>&nbsp;View
                          </ArgonButton>
                          <ArgonButton color="primary" size="small" fullWidth>
                            <Icon>edit</Icon>&nbsp;Edit
                          </ArgonButton>
                        </ArgonBox>
                      </ArgonBox>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </ArgonBox>
          </TabPanel>

          <TabPanel value={tabValue} index={2}>
            <ArgonBox px={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={3}>
                  <Card>
                    <ArgonBox p={2}>
                      <ArgonTypography variant="caption" color="text">
                        Total Units
                      </ArgonTypography>
                      <ArgonTypography variant="h4">11</ArgonTypography>
                      <ArgonBox mt={1} display="flex" alignItems="center">
                        <ArgonTypography variant="body2" color="success">
                          <Icon fontSize="small" sx={{ mr: 0.5 }}>arrow_upward</Icon>
                          5%
                        </ArgonTypography>
                        <ArgonTypography variant="caption" color="text" ml={1}>
                          from last quarter
                        </ArgonTypography>
                      </ArgonBox>
                    </ArgonBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Card>
                    <ArgonBox p={2}>
                      <ArgonTypography variant="caption" color="text">
                        Occupancy Rate
                      </ArgonTypography>
                      <ArgonTypography variant="h4">72.7%</ArgonTypography>
                      <ArgonBox mt={1} display="flex" alignItems="center">
                        <ArgonTypography variant="body2" color="success">
                          <Icon fontSize="small" sx={{ mr: 0.5 }}>arrow_upward</Icon>
                          3.2%
                        </ArgonTypography>
                        <ArgonTypography variant="caption" color="text" ml={1}>
                          from last month
                        </ArgonTypography>
                      </ArgonBox>
                    </ArgonBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Card>
                    <ArgonBox p={2}>
                      <ArgonTypography variant="caption" color="text">
                        Average Rent
                      </ArgonTypography>
                      <ArgonTypography variant="h4">$1,807</ArgonTypography>
                      <ArgonBox mt={1} display="flex" alignItems="center">
                        <ArgonTypography variant="body2" color="success">
                          <Icon fontSize="small" sx={{ mr: 0.5 }}>arrow_upward</Icon>
                          2.5%
                        </ArgonTypography>
                        <ArgonTypography variant="caption" color="text" ml={1}>
                          from last quarter
                        </ArgonTypography>
                      </ArgonBox>
                    </ArgonBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                  <Card>
                    <ArgonBox p={2}>
                      <ArgonTypography variant="caption" color="text">
                        Available Units
                      </ArgonTypography>
                      <ArgonTypography variant="h4">5</ArgonTypography>
                      <ArgonBox mt={1} display="flex" alignItems="center">
                        <ArgonTypography variant="body2" color="error">
                          <Icon fontSize="small" sx={{ mr: 0.5 }}>arrow_downward</Icon>
                          1
                        </ArgonTypography>
                        <ArgonTypography variant="caption" color="text" ml={1}>
                          from last month
                        </ArgonTypography>
                      </ArgonBox>
                    </ArgonBox>
                  </Card>
                </Grid>
                <Grid item xs={12}>
                  <Card sx={{ p: 3, height: "400px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <ArgonTypography variant="h6" color="text">
                      [Placeholder for detailed analytics charts]
                    </ArgonTypography>
                  </Card>
                </Grid>
              </Grid>
            </ArgonBox>
          </TabPanel>
        </Card>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Units;